module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zuhu"
  }, [_c('section', [(_vm.zuhu.queryFrom) ? _c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "请输入租户姓名"
    },
    model: {
      value: (_vm.filters.name),
      callback: function($$v) {
        _vm.$set(_vm.filters, "name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "filters.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [(_vm.zuhu.queryFrom) ? _c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.queryFrom()
      }
    }
  }, [_vm._v("查询")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', [(_vm.zuhu.queryFrom) ? _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.clearForm()
      }
    }
  }, [_vm._v("重置")]) : _vm._e()], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix header",
    staticStyle: {
      "font-size": "16px"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "card-header"
  }, [_vm._v("租户信息")]), _vm._v(" "), (_vm.zuhu.handleAdd) ? _c('el-button', {
    staticClass: "fr",
    attrs: {
      "size": "mini",
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.handleAdd()
      }
    }
  }, [_vm._v("新增")]) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.textMap[_vm.dialogStatus],
      "visible": _vm.dialogFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      },
      "close": _vm.emptyDialog
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "label-position": _vm.labelPosition,
      "model": _vm.editForm,
      "label-width": "100px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-row', [_c('el-form-item', {
    staticClass: "fl",
    staticStyle: {
      "width": "40%"
    },
    attrs: {
      "label": "租户名称:",
      "prop": "deptName"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.editForm.deptName),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "deptName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "editForm.deptName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "fr",
    staticStyle: {
      "width": "55%"
    },
    attrs: {
      "label": "访问路径:",
      "prop": "loginUrl"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入字母或者数字"
    },
    model: {
      value: (_vm.editForm.loginUrl),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "loginUrl", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "editForm.loginUrl"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-form-item', {
    staticClass: "fl",
    staticStyle: {
      "width": "40%"
    },
    attrs: {
      "label": "租户编码:",
      "prop": "deptCode"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.editForm.deptCode),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "deptCode", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "editForm.deptCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "fr",
    staticStyle: {
      "width": "55%"
    },
    attrs: {
      "label": "租户地址:",
      "prop": "deptAddr"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.editForm.deptAddr),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "deptAddr", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "editForm.deptAddr"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-form-item', {
    staticClass: "fl",
    staticStyle: {
      "width": "40%"
    },
    attrs: {
      "label": "联系人:",
      "prop": "deptLinkman"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.editForm.deptLinkman),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "deptLinkman", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "editForm.deptLinkman"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "fr",
    staticStyle: {
      "width": "55%"
    },
    attrs: {
      "label": "联系电话:",
      "prop": "deptLinkmanPhone"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.editForm.deptLinkmanPhone),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "deptLinkmanPhone", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "editForm.deptLinkmanPhone"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-form-item', {
    staticClass: "fl",
    staticStyle: {
      "width": "40%"
    },
    attrs: {
      "label": "电子邮箱:",
      "prop": "deptLinkmanEmail"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.editForm.deptLinkmanEmail),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "deptLinkmanEmail", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "editForm.deptLinkmanEmail"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "fr",
    staticStyle: {
      "width": "55%"
    },
    attrs: {
      "label": "是否启用:"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-value": 1,
      "inactive-value": -1
    },
    on: {
      "change": function($event) {
        return _vm.changeSwitch()
      }
    },
    model: {
      value: (_vm.formIsValid),
      callback: function($$v) {
        _vm.formIsValid = $$v
      },
      expression: "formIsValid"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注:",
      "prop": "memo"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.editForm.memo),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "memo", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "editForm.memo"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.dialogStatus == 'create') ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.createData
    }
  }, [_vm._v("添加")]) : _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.updateDataType
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.emptyDialog()
      }
    }
  }, [_vm._v("取消")])], 1)], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.users,
      "highlight-current-row": "",
      "border": "",
      "header-cell-style": {
        'text-align': 'center'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "dept.deptName",
      "label": "租户姓名",
      "width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([_vm._l((_vm.users), function(item, index) {
      return {
        key: "default",
        fn: function(scope) {
          return [(scope.row.dept !== null) ? _c('span', [_vm._v(_vm._s(scope.row.dept.deptName))]) : _c('span', [_vm._v("暂无")])]
        }
      }
    })], null, true)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "loginUrl",
      "label": "访问路径",
      "width": "150",
      "sortable": "",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "hasRole",
      "label": "是否授权",
      "width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([_vm._l((_vm.users), function(item, index) {
      return {
        key: "default",
        fn: function(scope) {
          return [(scope.row.hasRole == '0') ? _c('span', [_vm._v("否")]) : _vm._e(), _vm._v(" "), (scope.row.hasRole == '1') ? _c('span', [_vm._v("是")]) : _vm._e()]
        }
      }
    })], null, true)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "user.loginName",
      "label": "管理员账号",
      "width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([_vm._l((_vm.users), function(item, index) {
      return {
        key: "default",
        fn: function(scope) {
          return [(scope.row.user.loginName !== '') ? _c('span', [_vm._v(_vm._s(scope.row.user.loginName))]) : _c('span', [_vm._v("暂无")])]
        }
      }
    })], null, true)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "isValid",
      "label": "是否启用",
      "width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([_vm._l((_vm.users), function(item, index) {
      return {
        key: "default",
        fn: function(scope) {
          return [(scope.row.isValid == '1') ? _c('span', [_vm._v("启用")]) : _vm._e(), _vm._v(" "), (scope.row.isValid == '-1') ? _c('span', [_vm._v("停用")]) : _vm._e()]
        }
      }
    })], null, true)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "min-width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-dropdown', {
          attrs: {
            "trigger": "click"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "primary"
          }
        }, [_vm._v("\n              更多操作"), _c('i', {
          staticClass: "el-icon-arrow-down el-icon--right"
        })]), _vm._v(" "), _c('el-dropdown-menu', {
          attrs: {
            "slot": "dropdown"
          },
          slot: "dropdown"
        }, [(_vm.zuhu.changezuhu) ? _c('el-dropdown-item', {
          nativeOn: {
            "click": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("修改租户")]) : _vm._e(), _vm._v(" "), (scope.row.hasRole == "1" && _vm.zuhu.changeAllow) ? _c('el-dropdown-item', {
          nativeOn: {
            "click": function($event) {
              return _vm.changeAllow(scope.$index, scope.row)
            }
          }
        }, [_vm._v("修改授权")]) : _c('el-dropdown-item', {
          nativeOn: {
            "click": function($event) {
              return _vm.createAllow(scope.$index, scope.row)
            }
          }
        }, [_vm._v("租户授权")]), _vm._v(" "), (scope.row.hasRole == "1" && scope.row.user.loginName == "" && _vm.zuhu.createAdmin) ? _c('el-dropdown-item', {
          nativeOn: {
            "click": function($event) {
              return _vm.createAdmin(scope.$index, scope.row)
            }
          }
        }, [_vm._v("创建管理员")]) : _vm._e(), _vm._v(" "), (scope.row.user.loginName !== "" && _vm.zuhu.changePassWord) ? _c('el-dropdown-item', {
          nativeOn: {
            "click": function($event) {
              return _vm.changePassWord(scope.$index, scope.row)
            }
          }
        }, [_vm._v("重置密码")]) : _vm._e()], 1)], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "current-page": _vm.pages.page,
      "page-sizes": [10, 20, 50, 100],
      "page-size": _vm.pages.pageSize,
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.pages.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.textMenu[_vm.dialogStatus],
      "visible": _vm.dialogTableVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogTableVisible = $event
      },
      "close": _vm.emptyDialog2
    }
  }, [_c('el-form', {
    ref: "allowForm",
    attrs: {
      "label-position": _vm.labelPosition,
      "model": _vm.allowForm,
      "label-width": "100px",
      "rules": _vm.allowFormRules
    }
  }, [(_vm.dialogStatus == 'create') ? _c('el-form-item', {
    attrs: {
      "label": "角色名称:",
      "prop": "roleName"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.allowForm.roleName),
      callback: function($$v) {
        _vm.$set(_vm.allowForm, "roleName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "allowForm.roleName"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.dialogStatus == 'update') ? _c('el-form-item', {
    attrs: {
      "label": "角色名称:",
      "prop": "roleName"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.allowForm.roleName),
      callback: function($$v) {
        _vm.$set(_vm.allowForm, "roleName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "allowForm.roleName"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注:",
      "prop": "memo"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.allowForm.memo),
      callback: function($$v) {
        _vm.$set(_vm.allowForm, "memo", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "allowForm.memo"
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "20px 0"
    }
  }, [_vm._v("功能权限：")]), _vm._v(" "), _c('ul', {
    staticClass: "role-table row"
  }, [_c('li', {
    staticClass: "header2"
  }, [_c('div', {
    staticClass: "left",
    staticStyle: {
      "width": "30%",
      "text-align": "center"
    }
  }, [_vm._v("模块名称")]), _vm._v(" "), _c('div', {
    staticClass: "right",
    staticStyle: {
      "width": "70%",
      "text-align": "center"
    }
  }, [_vm._v("权限名称")])]), _vm._v(" "), _vm._l((_vm.testLists), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('div', {
      staticClass: "left h40",
      staticStyle: {
        "width": "30%",
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(item.menuName))]), _vm._v(" "), _c('div', {
      staticClass: "right h40",
      staticStyle: {
        "width": "70%",
        "text-align": "center"
      }
    }, [_c('el-checkbox-group', {
      model: {
        value: (_vm.checkList),
        callback: function($$v) {
          _vm.checkList = $$v
        },
        expression: "checkList"
      }
    }, _vm._l((item.children), function(m, index) {
      return _c('el-checkbox', {
        key: m.id,
        attrs: {
          "label": m.autId
        }
      }, [_vm._v(" \n              " + _vm._s(m.autName) + "\n            ")])
    }), 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "line"
    })])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "width": "30%",
      "margin": "20px auto"
    }
  }, [(_vm.dialogStatus == 'update') ? _c('el-button', {
    staticClass: "fl",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.saveRoleAuth('allowForm')
      }
    }
  }, [_vm._v("保存")]) : _c('el-button', {
    staticClass: "fl",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.createRoleAuth('allowForm')
      }
    }
  }, [_vm._v("添加")]), _vm._v(" "), _c('el-button', {
    staticClass: "fr",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "type": "warning"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogTableVisible = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "创建账号",
      "visible": _vm.dialogcreateAdmin
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogcreateAdmin = $event
      }
    }
  }, [_c('el-form', {
    ref: "createAdminForm",
    attrs: {
      "label-position": _vm.labelPosition,
      "model": _vm.createAdminForm,
      "label-width": "100px",
      "rules": _vm.createAdminFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "登录名:",
      "prop": "loginName"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.createAdminForm.loginUrl) + "_")]), _vm._v(" "), _c('el-input', {
    model: {
      value: (_vm.createAdminForm.loginName),
      callback: function($$v) {
        _vm.$set(_vm.createAdminForm, "loginName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "createAdminForm.loginName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "密码:",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.createAdminForm.password),
      callback: function($$v) {
        _vm.$set(_vm.createAdminForm, "password", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "createAdminForm.password"
    }
  }), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("(默认密码为\"New@0987\")")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.createAdminData()
      }
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.dialogcreateAdmin = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "信息提示:",
      "visible": _vm.dialogPassWordVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogPassWordVisible = $event
      }
    }
  }, [_c('p', [_vm._v("确认重置租户'" + _vm._s(_vm.passwordForm.dept.deptName) + "'的密码？（重置后的密码为'" + _vm._s(_vm.passwordForm.password) + "'）")]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.updateData
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.dialogPassWordVisible = false
      }
    }
  }, [_vm._v("取消")])], 1)])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-43ddfc6b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/navZuhu/zuhu.vue
// module id = 1653
// module chunks = 0